import { RMASettings } from '@cbgms/api'
import useQuery, { useMutation, useQueryClient } from '@cbgms/base/http/use-query'
import { getReturnSettings, putReturnSettings } from 'app/settings/state/ReturnSettings/actions'
import { useDispatch } from 'react-redux'

const RETURN_SETTINGS_KEY = ['RETURN-SETTINGS']

export const useGetReturnSettings = () => {
  const dispatch = useDispatch()
  return useQuery(
    RETURN_SETTINGS_KEY,
    () => {
      return dispatch(getReturnSettings())
    },
    { refetchOnWindowFocus: false, staleTime: 5 * 60 * 1000 }
  )
}

export const useReturnSettingsMutator = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  return useMutation(
    async (newValues: RMASettings) => {
      return dispatch(putReturnSettings(newValues))
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(RETURN_SETTINGS_KEY)
      }
    }
  )
}

export default useGetReturnSettings
